/**
 *
 * key
 *
 */


const key = 'b3BlcmF0aW9uc0ZvbGxvd1Vw'

export default key